import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SegnalibriComponent } from './segnalibri.component';


const routes: Routes = [
  {
    path: '', component: SegnalibriComponent,
    data: { title: 'Vedi e Prova Segnalibri' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SegnalibriRoutingModule { }
